import { ChartModel } from './chart.model';
/**
 * Number chart model definition
 */
export class NumberChartModel extends ChartModel {
/**
 * Background color for each data item card
 */
backgroundColor?: string;
/**
 * Background color for each data item card, when data is not defined (empty)
 */
emptyBackgroundColor?: string;
/**
 * Text color for each data item card
 */
textColor?: string;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super();
    Object.assign(this, values);
  }
}

function NumberChartModel_tsickle_Closure_declarations() {
/**
 * Background color for each data item card
 * @type {?}
 */
NumberChartModel.prototype.backgroundColor;
/**
 * Background color for each data item card, when data is not defined (empty)
 * @type {?}
 */
NumberChartModel.prototype.emptyBackgroundColor;
/**
 * Text color for each data item card
 * @type {?}
 */
NumberChartModel.prototype.textColor;
}

